<template>
  <modal name="guarantee-modal"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Տվյալներն ուղարկել ՎՏԲ-Հայաստան Բանկ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('guarantee-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4">
      <div class="form-group">
        <label for="name">Անվանում</label>
        <input v-model="$v.name.$model" type="text" class="form-control" id="name" placeholder="Անվանում">
      </div>
      <div class="form-group">
        <label for="director_name">Տնօրենի Անուն Ազգանուն</label>
        <input v-model="$v.director_name.$model" type="text" class="form-control" id="director_name" placeholder="Տնօրենի Անուն Ազգանուն">
      </div>
      <div class="form-group">
        <label for="phone">Հեռախոսահամարը</label>
        <input v-model="$v.phone.$model" type="text" class="form-control" id="phone" placeholder="Հեռախոսահամարը">
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 text-right" style="bottom: 0">
      <div class="row justify-content-center p-3">
        <button @click="send" class="btn btn-primary">
          Դիմել
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GuaranteeModal',
  data () {
    return {
      name : null,
      director_name : null,
      phone : null,
    }
  },
  validations: {
    name : { required },
    director_name : { required },
    phone : { required },
  },
  mounted(){
    if(this.me.organisation){
      this.name = `${this.me.organisation[0].translations.name.hy} «${this.me.organisation[0].translations.company_type.hy}»`;
      this.director_name = this.me.organisation[0].translations.director_name.hy;
      this.phone = this.me.phone;
    }
  },
  watch: {
    me(){
      if(this.me.organisation){
        this.name = `${this.me.organisation[0].translations.name.hy} «${this.me.organisation[0].translations.company_type.hy}»`;
        this.director_name = this.me.organisation[0].translations.director_name.hy;
        this.phone = this.me.phone;
      }
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    send(){
      this.$v.$touch()
      if(!this.$v.$invalid) {
        const requestData ={
          name: this.name,
          director_name: this.director_name,
          phone: this.phone,
        }
        this.$client.post('send/email/guarantee', requestData).then(({data}) => {
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Դուք հաջողությամբ դիմեցիք երաշխիքի համար'
          })
          this.$modal.hide('guarantee-modal')
        })
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Լրացրեք բոլոր դաշտերը պահպանելու համար!'
        })
      }
    },
    beforeOpen() {
      
    },
  }
}
</script>
<style scoped>
  .purchase-btn{
    cursor: pointer;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    margin: auto;
    position: absolute;
    width: 30% !important;
    height: 50% !important;
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>

